<div id="container"> 
    <button (click)="createGoal()" id="flow-button">Add Goal</button>
    <ng-container *ngFor="let g of goals">
        <app-goals-item *ngIf="(g.parentGoal==null)&&(g.type===type_display)" [goal]="g" [all_goals]="goals"></app-goals-item>
    </ng-container>
</div>
